import { render, staticRenderFns } from "./custom-info-icon-header.vue?vue&type=template&id=6c2bfb5e"
import script from "./custom-info-icon-header.vue?vue&type=script&lang=js"
export * from "./custom-info-icon-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports